const SLUG_PREFIX_REGEX = '^\\/[a-z0-9]+(?:-[a-z0-9]+)*\\/[a-z0-9]+(?:-[a-z0-9]+)*\\/';
export const shouldPreventSearchesOnSubViews = (currentPage, lastURL) => {
    var _a, _b;
    const pathName = new URL(currentPage.url).pathname;
    const basePathName = (_a = pathName.match(SLUG_PREFIX_REGEX)) === null || _a === void 0 ? void 0 : _a[0];
    return (lastURL === null || lastURL === void 0 ? void 0 : lastURL.includes(basePathName)) && ((_b = currentPage.url) === null || _b === void 0 ? void 0 : _b.includes(basePathName));
};
